import DevelopmentSummaryDetailContainer from "containers/hr-metrics/development-summary/DevelopmentSummaryDetailContainer"
import DevelopmentSummaryListContainer from "containers/hr-metrics/development-summary/DevelopmentSummaryListContainer"
import EmployeeProductivityCreateContainer from "containers/hr-metrics/employee-productivity/create/EmployeeProductivityCreateContainer"
import EmployeeProductivityDetailContainer from "containers/hr-metrics/employee-productivity/EmployeeProductivityDetailContainer"
import EmployeeProductivityListContainer from "containers/hr-metrics/employee-productivity/EmployeeProductivityListContainer"
import HappinessIndexCreateContainer from "containers/hr-metrics/happiness-index/create/HappinessIndexCreateContainer"
import HappinessIndexDetailContainer from "containers/hr-metrics/happiness-index/HappinessIndexDetailContainer"
import HappinessIndexListContainer from "containers/hr-metrics/happiness-index/HappinessIndexListContainer"
import InternalMovementListContainer from "containers/hr-metrics/internal-movement/InternalMovementListContainer"

export const HR_METRICS_ROUTE_LIST = [
    {
        path: '/human-resource-metrics/employee-happiness-index',
        component: <HappinessIndexListContainer />
    },
    {
        path: '/human-resource-metrics/create-happiness-index/:step',
        component: <HappinessIndexCreateContainer />
    },
    {
        path: '/human-resource-metrics/employee-happiness-index/detail-happiness-index',
        component: <HappinessIndexDetailContainer />
    },
    {
        path: '/human-resource-metrics/employee-productivity',
        component: <EmployeeProductivityListContainer />
    },
    {
        path: '/human-resource-metrics/create-employee-productivity/:step',
        component: <EmployeeProductivityCreateContainer />
    },
    {
        path: '/human-resource-metrics/employee-productivity/detail-employee-productivity',
        component: <EmployeeProductivityDetailContainer />
    },
    {
        path: '/human-resource-metrics/employee-internal-movement',
        component: <InternalMovementListContainer />
    },
    {
        path: '/human-resource-metrics/employee-development-summary',
        component: <DevelopmentSummaryListContainer />
    },
    {
        path: '/human-resource-metrics/employee-development-summary/detail-development-summary',
        component: <DevelopmentSummaryDetailContainer />
    },
]